import type { ISVGIconProps } from "@ab.uitools/ui-library/components/SVGIcons/types";
import classNames from "classnames";

export const JPYSymbolIcon = ({
  size,
  type,
  className = "",
  onClick,
  refHandler,
  id,
  dataId,
}: ISVGIconProps) => {
  return (
    <svg
      className={classNames("svg-icon", {
        [`svg-icon__size-${size}`]: size,
        [`svg-icon__type-${type}`]: type,
        [className]: className,
      })}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      ref={refHandler}
      id={id}
      data-id={dataId ? `${dataId}-svg-icon` : ""}
    >
      <path
        d="M6.26695 3.31065C6.07901 3.00479 5.67871 2.9092 5.37285 3.09714C5.06699 3.28509 4.9714 3.68539 5.15935 3.99125L9.07039 10.3561H7.08305C6.72406 10.3561 6.43305 10.6471 6.43305 11.0061C6.43305 11.365 6.72406 11.6561 7.08305 11.6561H9.34731V12.7971H7.08305C6.72406 12.7971 6.43305 13.0881 6.43305 13.4471C6.43305 13.8061 6.72406 14.0971 7.08305 14.0971H9.34731V16.3491C9.34731 16.7081 9.63833 16.9991 9.99731 16.9991C10.3563 16.9991 10.6473 16.7081 10.6473 16.3491V14.0971H12.9168C13.2758 14.0971 13.5668 13.8061 13.5668 13.4471C13.5668 13.0881 13.2758 12.7971 12.9168 12.7971H10.6473V11.6561H12.9168C13.2758 11.6561 13.5668 11.365 13.5668 11.0061C13.5668 10.6471 13.2758 10.3561 12.9168 10.3561H10.9247L14.8405 3.99156C15.0286 3.6858 14.9332 3.28545 14.6275 3.09733C14.3217 2.90922 13.9214 3.00459 13.7332 3.31034L9.99766 9.38198L6.26695 3.31065Z"
        fill="#888888"
      />
    </svg>
  );
};
